import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { TranslatePipe } from '@pipes/translate.pipe';

import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserHelper } from '@helpers/user.helper';
import { DataHelper } from '@helpers/data.helper';
import { addDays } from 'date-fns';
import { DataService } from '@services/data.service';

export interface IComparisonData {
  AwayTeam: string;
  Company: string;
  CurrentOddValue: number;
  EventDate: string;
  ExtensionData: object;
  ExternalOddValue: number;
  HomeTeam: string;
  MatchId: number;
  MatchName: string;
  OddId: number;
  OddTypeId: number;
  OutCome: string;
  SpecialValue: string;
}

@Component({
  selector: 'compare-prematch-component',
  templateUrl: '../sharedTemplates/compare-prematch.component.html',
})
export class ComparePreMatchComponent implements OnInit, OnDestroy {
  possibleChanceCurrent = 1;
  possibleChanceExternal = 1;
  PER_PAGE_COUNT = 6;
  currentPage = 0;
  balance = 20;
  comparisonData: Array<IComparisonData> = [];
  slicedComparisonData: Array<IComparisonData> = [];
  isLastPage = false;

  today = new Date();
  //dmoment sevenDayAfter1 = moment(this.today).add(7, "days").toDate();
  sevenDayAfter = addDays(this.today, 7);

  styles = {
    vScrool: { height: this._UiHelper.windowsHeight - 200 + 'px' },
  };
  oddTypes = this._DataHelper.oddTypes;

  constructor(
    private _ApiService: ApiService,
    public _DataHelper: DataHelper,

    private _UiHelper: UiHelper,
    private _LocalizationService: LocalizationService,
    private _DataService: DataService,
    public _UserHelper: UserHelper,
    public _Router: Router
  ) {
    this._UiHelper.windowResized.subscribe(c => {
      this.styles.vScrool.height = this._UiHelper.windowsHeight - 160 + 'px';
    });
    this.styles.vScrool.height = this._UiHelper.windowsHeight - 160 + 'px';
  }

  ngOnInit() {
    this._DataService.activeList.getOddComparison = true;
    this._DataService.setDataGetter('getOddComparison', 2 * 60);
    this._DataHelper.comparisonDataListener.subscribe((x: any) => {
      this.othersBet();
    });
    if (this._DataHelper.comparisonData.length > 0) {
      this.othersBet();
    }
  }

  ngOnDestroy() {
    this._DataService.activeList.getOddComparison = false;
  }

  goEventDetail(e) {
    this._Router.navigate(['/eventdetail', e]);
  }

  getWhich(matchDate: Date): number {
    const _today = new Date(this.today).getDate();
    const _matchDate = new Date(matchDate).getDate();

    const _month = new Date(this.today).getMonth();
    const _monthDate = new Date(matchDate).getMonth();

    if (_today === _matchDate && _month == _monthDate) {
      return 1;
    }

    if (this.sevenDayAfter > new Date(matchDate)) {
      return 2;
    }

    return 3;
  }

  goEventDetail2(e, f, g) {
    this._DataHelper.selectedMatch = g;
    const ismobile = this._UiHelper.windowsWidth < 990 ? true : false;
    if (g == null) {
      if (ismobile) {
        const matchId = e == null ? f : e;
        this._UiHelper.setMatchDetailData(matchId, false);
      } else {
        this._Router.navigate(['/eventdetail', e == null ? f : e]);
      }
    } else if (g.HasStreaming == null || g.HasStreaming == 'pre' || g.HasStreaming == false) {
      if (ismobile) {
        const matchId = e == null ? f : e;
        this._UiHelper.setMatchDetailData(matchId, false);
      } else {
        this._Router.navigate(['/eventdetail', e == null ? f : e]);
      }
    } else {
      if (ismobile) {
        const matchId = e == null ? f : e;
        this._UiHelper.setMatchDetailData(matchId, true);
      } else {
        this._Router.navigate(['/liveeventdetail', e == null ? f : e]);
      }
    }
    this._UiHelper.b3000SetMatchDetailDialog('open');
  }

  clickNewOdd() {
    const translator = new TranslatePipe(this._LocalizationService);

    const _market = translator.transform('tipp', null);

    const slipstring = JSON.stringify([]);
    localStorage.setItem('currentslip', slipstring);
    this._ApiService.slipCurrents = JSON.parse(localStorage.getItem('currentslip'));

    this.slicedComparisonData.forEach(element => {
      const newOdd = {
        Banko: false,
        BetType: 0,
        Enable: true,
        EventDateLong: element.EventDate,
        EventName: element.HomeTeam + ' - ' + element.AwayTeam,
        MatchId: element.MatchId,
        OddId1: element.OddId,
        OddsType: _market,
        OddsTypeId: element.OddTypeId,
        OddValue1: element.CurrentOddValue,
        OutCome: element.OutCome,
        ShortOddType: _market,
        SpecialBetValue: '',
        Visibility: '',
        HomeTeam: element.HomeTeam,
        AwayTeam: element.AwayTeam,
      };

      this._ApiService.addOddDirectlyWithoutNotify(newOdd);
    });
    this._DataHelper.currentSlipInfo.currentslip_totalStake = this.balance;
    this._ApiService.getCurrentSlip();

    this._DataHelper.currentSlipInfo.currentslip_totalStake = this.balance;

    this._UiHelper.closeAllMenus();
    this._UiHelper.b3000SetMatchDetailDialog('close');
    this._UiHelper.b3000SetBottomDialogState('open');
  }

  getComparisonData() {
    this._ApiService.getOddComparison().then((x: Array<IComparisonData>) => {
      this.comparisonData = x;
      this.othersBet();
    });
  }
  othersBet(currentPageEvent?) {
    this.possibleChanceCurrent = 1;
    this.possibleChanceExternal = 1;
    if (currentPageEvent) {
      this.currentPage += 1;
    }
    if (this.isLastPage) {
      this.currentPage = 0;
      this.isLastPage = false;
    }
    if (this._DataHelper.comparisonData.length > 0) {
      this.slicedComparisonData = this._DataHelper.comparisonData.slice(this.currentPage * this.PER_PAGE_COUNT, (this.currentPage + 1) * this.PER_PAGE_COUNT);
      if (this.slicedComparisonData.length < this.PER_PAGE_COUNT) {
        this.currentPage = 0;
        this.isLastPage = true;
        if (this.slicedComparisonData.length == 0) {
          this.othersBet();
        }
      }
      this.possibleChanceCurrent = 1;
      this.possibleChanceExternal = 1;

      this.slicedComparisonData.forEach(element => {
        this.possibleChanceCurrent *= element.CurrentOddValue;
        this.possibleChanceExternal *= element.ExternalOddValue;
      });
    }
  }
}
